// Lightweight city index — ONLY slug / name / countyId, for the parts of the
// shared shell that render on every page (footer service-areas grid, nav).
// The full city copy lives in ./cities-king.js, ./cities-pierce.js,
// ./cities-snohomish.js and is bundled into the /plumber/:slug route chunk only
// (see ./cities.js). Keeping this file tiny keeps ~200 KB of prose out of the
// main JavaScript bundle on every page.
//
// To add a city: append it to the right county file AND to CITY_INDEX below.
// The production build fails (scripts/prerender-entry.jsx → assertDataIndexesInSync)
// and the dev server warns (./cities.js) if the two ever disagree.

export const COUNTIES = [
  {
    id: "king",
    name: "King County",
    short: "King",
    blurb: "Seattle, the Eastside, and South King County — most of it within 45 minutes of our Federal Way headquarters.",
  },
  {
    id: "pierce",
    name: "Pierce County",
    short: "Pierce",
    blurb: "Tacoma, the Puyallup valley, the Gig Harbor peninsula, and the South Pierce prairie — our home county, 10 to 35 minutes out.",
  },
  {
    id: "snohomish",
    name: "Snohomish County",
    short: "Snohomish",
    blurb: "Our farthest Puget Sound coverage, 50 to 90 minutes from Federal Way. Scheduled service is booked in confirmed arrival windows; 24/7 emergency dispatch is still available with an honest ETA.",
    extended: true,
  },
];

export const CITY_INDEX = [
  { slug: "seattle", name: "Seattle", countyId: "king" },
  { slug: "kent", name: "Kent", countyId: "king" },
  { slug: "auburn", name: "Auburn", countyId: "king" },
  { slug: "bellevue", name: "Bellevue", countyId: "king" },
  { slug: "renton", name: "Renton", countyId: "king" },
  { slug: "burien", name: "Burien", countyId: "king" },
  { slug: "des-moines", name: "Des Moines", countyId: "king" },
  { slug: "seatac", name: "SeaTac", countyId: "king" },
  { slug: "tukwila", name: "Tukwila", countyId: "king" },
  { slug: "kirkland", name: "Kirkland", countyId: "king" },
  { slug: "redmond", name: "Redmond", countyId: "king" },
  { slug: "sammamish", name: "Sammamish", countyId: "king" },
  { slug: "issaquah", name: "Issaquah", countyId: "king" },
  { slug: "shoreline", name: "Shoreline", countyId: "king" },
  { slug: "bothell", name: "Bothell", countyId: "king" },
  { slug: "kenmore", name: "Kenmore", countyId: "king" },
  { slug: "maple-valley", name: "Maple Valley", countyId: "king" },
  { slug: "covington", name: "Covington", countyId: "king" },
  { slug: "mercer-island", name: "Mercer Island", countyId: "king" },
  { slug: "tacoma", name: "Tacoma", countyId: "pierce" },
  { slug: "puyallup", name: "Puyallup", countyId: "pierce" },
  { slug: "lakewood", name: "Lakewood", countyId: "pierce" },
  { slug: "fife", name: "Fife", countyId: "pierce" },
  { slug: "sumner", name: "Sumner", countyId: "pierce" },
  { slug: "bonney-lake", name: "Bonney Lake", countyId: "pierce" },
  { slug: "university-place", name: "University Place", countyId: "pierce" },
  { slug: "spanaway", name: "Spanaway", countyId: "pierce" },
  { slug: "parkland", name: "Parkland", countyId: "pierce" },
  { slug: "graham", name: "Graham", countyId: "pierce" },
  { slug: "frederickson", name: "Frederickson", countyId: "pierce" },
  { slug: "gig-harbor", name: "Gig Harbor", countyId: "pierce" },
  { slug: "lynnwood", name: "Lynnwood", countyId: "snohomish" },
  { slug: "edmonds", name: "Edmonds", countyId: "snohomish" },
  { slug: "mountlake-terrace", name: "Mountlake Terrace", countyId: "snohomish" },
  { slug: "mill-creek", name: "Mill Creek", countyId: "snohomish" },
  { slug: "mukilteo", name: "Mukilteo", countyId: "snohomish" },
  { slug: "everett", name: "Everett", countyId: "snohomish" },
  { slug: "lake-stevens", name: "Lake Stevens", countyId: "snohomish" },
  { slug: "marysville", name: "Marysville", countyId: "snohomish" },
  { slug: "arlington", name: "Arlington", countyId: "snohomish" },
  { slug: "monroe", name: "Monroe", countyId: "snohomish" },
];

export const getCountyById = (id) => COUNTIES.find((c) => c.id === id) || null;
